export default (style) => style ?? ''
